<template>
   <div>
     <apexchart :height="height" :options="chartOptions" :series="series"></apexchart>
   </div>
</template>
<script>
import codeHelper from '../../../helper/staticCodeHelper';

export default {
  name: "BarChartHorizontal",
  props:['height','chartid'],
  data: function (){
     return {
        chartOptions: this.getChartOptions(['label1','label2']),
        series: [],
     }
  }, 
  mounted () {
  },
  methods:{
    ...codeHelper,
    setSeries(series){
      if(this.IsNotNull(series))
      {
        this.series = series;
      }      
    },
    setLabels(labels){
      if(this.IsNotNull(labels))
      {
        this.chartOptions = this.getChartOptions(labels);
      }      
    },
    getChartOptions(labels){
      var options = {
          chart: {
            type: 'bar',
            id: this.chartid,
            labels:this.height,
            stacked: true,
            toolbar:{ show:false}
          },
          colors: ['#be1f37', '#595959', '#8c7406', '#490723', '#b94456'],
          noData: {
            text: "Keine Daten",
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: '14px',
              fontFamily: undefined
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
              dataLabels: {
                  total: {
                    enabled: true
                  }
              }
            }
          },
          dataLabels:{
            enabled:false
          },
          xaxis: {
              categories: labels,
              labels: {
                formatter: function (val) {
                  return val + "€"
                }
              }
            },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + "€"
              }
            }
          },
          yaxis: {
            title: {
              text: undefined
            },
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
          }
        };
        return options;
    }
  },
  computed:{
   
  },
  watch:{
    
  }
};
</script>